import { render, staticRenderFns } from "./aftersale_order_member.vue?vue&type=template&id=3eb5bb0f&scoped=true"
import script from "./aftersale_order_member.vue?vue&type=script&lang=js"
export * from "./aftersale_order_member.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb5bb0f",
  null
  
)

export default component.exports